import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useStatLocalStorage } from '@famly/stat_ts-utils_use-stat-local-storage';
import { checkIfFlagIsToggled, DebugLocalStorageFlags } from '@famly/vet_ts-utils_local-storage-config';
import { Tooltip } from '@famly/mf_data-display_tooltip';
import { Box } from '@famly/mf_layout_box';
import { Icon } from '@famly/mf_data-display_icon';
import { FormHeaderValuesDialog } from './form-header-values-dialog';
const showDetailsLocalStorageFlag = 'showStatFormDetails';
export const FormHeaderDebug = () => {
    var _a;
    const { control } = useFormContext();
    const formValues = useWatch({ control });
    const localStorage = useStatLocalStorage([showDetailsLocalStorageFlag]);
    const [showDebugDetails, setShowDebugDetails] = React.useState(Boolean(JSON.parse((_a = localStorage[showDetailsLocalStorageFlag]) !== null && _a !== void 0 ? _a : 'false')));
    React.useEffect(() => {
        localStorage[showDetailsLocalStorageFlag] = JSON.stringify(showDebugDetails);
    }, [localStorage, showDebugDetails]);
    if (!checkIfFlagIsToggled(DebugLocalStorageFlags.SHOW_STAT_FORM_DEBUG.flag)) {
        return null;
    }
    return (_jsx(Tooltip, { tooltipContent: _jsx(React.Suspense, { fallback: null, children: _jsx(FormHeaderValuesDialog, { formValues: formValues }) }), children: _jsx(Box, { cursor: "pointer", onClick: () => setShowDebugDetails(current => !current), children: _jsx(Icon, { name: "bug_report", size: 28 }) }) }));
};
